import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import {
  isForbiddenError,
  isNotFoundError,
  isUnauthorizedError,
  isUnprocessableContentError,
  R,
} from 'core/helpers'
import { useCompanyAppDomainGet } from 'core/types'

import ModelLink from './ModelLink'

type AppDomainLinkProps = {
  appDomainId: string
}

const AppDomainLink: FC<AppDomainLinkProps> = ({ appDomainId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: appDomain, isLoading } = useCompanyAppDomainGet({
    companyId,
    companyAppDomainId: appDomainId,
    options: {
      throwOnError: (error) =>
        R.isNot(isForbiddenError)(error) &&
        R.isNot(isNotFoundError)(error) &&
        R.isNot(isUnprocessableContentError)(error) &&
        R.isNot(isUnauthorizedError)(error),
    },
  })

  return <ModelLink id={appDomainId} isLoading={isLoading} model={appDomain} />
}

export default AppDomainLink
